import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  text: string;
}

const RiskBadge: React.FC<Props> = ({ text }) => {
  const { t } = useTranslation();

  const values = ['Low', 'Moderate', 'High'];

  const textInValues = values.includes(text);
  const getClass = (ix: number) => (values.slice(ix).indexOf(text) !== -1 ? text : '');

  return textInValues ? (
    <div className="badge-base">
      <div className="badge-bargroup risk">
        <div className={`badge-bar ${getClass(0)}`} />
        <div className={`badge-bar ${getClass(1)}`} />
        <div className={`badge-bar ${getClass(2)}`} />
        <div className="badge-text">
          <span>{t(`riskCodes.${text}`)}</span>
        </div>
      </div>
    </div>
  ) : (
    'N/A'
  );
};

export default React.memo(RiskBadge);
